import React from "react"
import tw, { styled, css } from "twin.macro"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

// Utils
import { SlideProps } from "."

// Components
import NextPageButton from "../components/nextPageButton"
import SlideSection from "../components/slideSection"
import NextPageContainer from "../components/nextPageContainer"

const Header = styled.h2`
  ${tw`md:block text-center font-sans text-2xl mb-6`}
`

const Description = styled.p`
  ${tw`text-center font-sans text-sm mb-6`}
`

const TrainingSlide: React.SFC<SlideProps> = ({
  slideVisible,
  nextButtonClicked,
}) => {


  const data = useStaticQuery(query);

  const leftSource = [
    {
      ...data.trainingLeft.childImageSharp.fluid,
      media: `(min-width: 768px)`,
    },
  ]
  const rightSource = [
    {
      ...data.trainingRight.childImageSharp.fluid,
      media: `(min-width: 768px)`,
    },
  ]
  return (
    <SlideSection fullHeight>
      <div css={[tw`flex flex-col md:flex-row h-full justify-end md:justify-center items-center pb-32 md:pb-0`]}>
        <div css={[
          tw`absolute top-0 md:bottom-0 right-0 w-1/2 z-0`, css`height: 90%;`,
          // transitions
          tw`transition duration-500 ease-out delay-100`,
          !slideVisible && tw`opacity-0 transform translate-x-16`
        ]}>
          <Img css={[tw`flex h-full`]} fluid={rightSource} imgStyle={{ objectFit: 'contain', objectPosition: 'top' }} />
        </div>
        <div css={[tw`z-10 w-full md:w-1/3 px-4 md:px-0`, css`max-width: 400px;`]}>
          <Header css={[tw`font-text font-bold text-standard-title`, css`line-height: 1.2em;`]}>Ongoing training support</Header>
          <Description css={[tw`font-text leading-7 md:leading-8 text-sm tracking-normal mr-4 ml-4`]}>
            MITO sets the standard with intuitive online and practical training programmes designed in collaboration with industry. Your dedicated MITO Training Advisor provides ongoing support, ensuring your Apprentice is on track with their learning from day one.
          </Description>
        </div>

        <NextPageContainer>
          <NextPageButton
            onClick={nextButtonClicked}
            label=""
          />
        </NextPageContainer>
      </div>


    </SlideSection>
  )
}

export const query = graphql`
  query {
    trainingLeft: file(relativePath: { eq: "TrainingLeft.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000, quality: 100) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    trainingRight: file(relativePath: { eq: "TrainingRight.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000, quality: 100) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`

export default TrainingSlide
